export default __webpack_public_path__ + "3f07ed67f06c720120cedd0bad5f60e2.woff";